import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppShell from "../../components/layout/AppShell";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";

export default function ReferralPerformance() {
  const [tab, setTab] = useState("customers");
  const [cust, setCust] = useState([]);
  const [parts, setParts] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [c, p] = await Promise.all([
          api.get("/referrals/performance/customers"),
          api.get("/referrals/performance/partners"),
        ]);
        setCust(c.data); setParts(p.data);
      } catch (e) { toast.error(formatApiError(e)); }
    })();
  }, []);

  return (
    <AppShell title="Performance" subtitle="Customer referrals & partner registrations">
      <div className="flex gap-0 mb-4 border border-[#E5E2D9] rounded-md overflow-hidden w-fit" data-testid="perf-tabs">
        <button onClick={() => setTab("customers")} data-testid="tab-customers"
                className={`h-10 px-4 text-xs font-medium ${tab === "customers" ? "bg-[#2D5A27] text-white" : "bg-white text-[#5C5A55]"}`}>
          A · Customer Referrals ({cust.length})
        </button>
        <button onClick={() => setTab("partners")} data-testid="tab-partners"
                className={`h-10 px-4 text-xs font-medium border-l border-[#E5E2D9] ${tab === "partners" ? "bg-[#2D5A27] text-white" : "bg-white text-[#5C5A55]"}`}>
          B · Partner Performance ({parts.length})
        </button>
      </div>

      {tab === "customers" && (
        <div className="bg-white border border-[#E5E2D9] rounded-md overflow-hidden" data-testid="perf-customers">
          <table className="w-full text-sm">
            <thead className="bg-[#F7F6F2] text-[10px] uppercase tracking-[0.2em] text-[#5C5A55]">
              <tr>
                <th className="text-left px-5 py-2.5">Customer</th>
                <th className="text-left px-3 py-2.5">Phone</th>
                <th className="text-right px-3 py-2.5">Referrals</th>
                <th className="text-right px-3 py-2.5">Earned</th>
                <th className="text-right px-3 py-2.5">Paid</th>
                <th className="text-right px-3 py-2.5">Available</th>
              </tr>
            </thead>
            <tbody>
              {cust.length === 0 && <tr><td colSpan={6} className="p-10 text-center text-[#8A8780]">No referrals yet.</td></tr>}
              {cust.map(r => (
                <tr key={r.customer_id} className="border-t border-[#F0ECE3]">
                  <td className="px-5 py-3">
                    <div className="font-medium">{r.name}</div>
                    <div className="text-xs text-[#5C5A55] font-mono">{r.customer_code}</div>
                  </td>
                  <td className="px-3 py-3 font-mono text-xs">{r.phone || "—"}</td>
                  <td className="px-3 py-3 text-right">{r.referrals}</td>
                  <td className="px-3 py-3 text-right font-mono">₹{r.total_earned.toFixed(2)}</td>
                  <td className="px-3 py-3 text-right font-mono text-[#5C5A55]">₹{r.total_paid.toFixed(2)}</td>
                  <td className="px-3 py-3 text-right font-mono text-[#2D5A27]">₹{r.available.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {tab === "partners" && (
        <div className="bg-white border border-[#E5E2D9] rounded-md overflow-hidden overflow-x-auto" data-testid="perf-partners">
          <table className="w-full text-sm min-w-[900px]">
            <thead className="bg-[#F7F6F2] text-[10px] uppercase tracking-[0.2em] text-[#5C5A55]">
              <tr>
                <th className="text-left px-5 py-2.5">Partner</th>
                <th className="text-left px-3 py-2.5">Type</th>
                <th className="text-left px-3 py-2.5">Comm</th>
                <th className="text-right px-3 py-2.5">Customers</th>
                <th className="text-right px-3 py-2.5">Earned</th>
                <th className="text-right px-3 py-2.5">Paid</th>
                <th className="text-right px-3 py-2.5">Balance</th>
                <th className="px-3 py-2.5"></th>
              </tr>
            </thead>
            <tbody>
              {parts.length === 0 && <tr><td colSpan={8} className="p-10 text-center text-[#8A8780]">No partners yet.</td></tr>}
              {parts.map(p => (
                <tr key={p.partner_id} className="border-t border-[#F0ECE3]">
                  <td className="px-5 py-3 font-medium">
                    <Link to={`/customers/referrals/partners/${p.partner_id}`} className="hover:underline">{p.name}</Link>
                    <div className="text-[10px] font-mono text-[#8A8780]">{p.phone || "—"}</div>
                  </td>
                  <td className="px-3 py-3">
                    <span className="px-2 py-0.5 text-[10px] uppercase tracking-[0.18em] rounded bg-[#D4E0D1] text-[#2D5A27]">{p.type}</span>
                  </td>
                  <td className="px-3 py-3">
                    {p.commission_enabled === false ? (
                      <span className="px-2 py-0.5 text-[9px] uppercase tracking-wider rounded bg-[#F7F6F2] text-[#8A8780] border border-[#E5E2D9]">OFF</span>
                    ) : (
                      <span className="px-2 py-0.5 text-[9px] uppercase tracking-wider rounded bg-[#D4E0D1] text-[#2D5A27]">ON</span>
                    )}
                  </td>
                  <td className="px-3 py-3 text-right">
                    <span className="font-mono">{p.customers_count}</span>
                    <span className="text-[10px] text-[#8A8780] ml-1">({p.active_customers} active)</span>
                  </td>
                  <td className="px-3 py-3 text-right font-mono">₹{Number(p.total_earned||0).toFixed(2)}</td>
                  <td className="px-3 py-3 text-right font-mono text-[#5C5A55]">₹{Number(p.total_paid||0).toFixed(2)}</td>
                  <td className="px-3 py-3 text-right font-mono text-[#2D5A27]">₹{Number(p.available||0).toFixed(2)}</td>
                  <td className="px-3 py-3 text-right">
                    <Link to={`/customers/referrals/partners/${p.partner_id}`}
                           data-testid={`perf-open-${p.partner_id}`}
                           className="text-xs text-[#2D5A27] hover:underline inline-flex items-center gap-1">
                      open →
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AppShell>
  );
}
